import CellHOC from '@platform/react/hoc/list/cell'
import { def, getFirstItem } from 'lib/util'
import Chip from 'ui/Element/Text/Chip'
import settings from '@tenant/settings'

const styles = theme => ({
  row: {
    display: 'flex',
  },
  root: {
    display: 'flex',
  },
  container: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    borderRadius: '2.5rem',
    width: 'auto',
  },
  text: {
    textTransform: 'uppercase',
  },
})

/**
 * Intended to display the name of the status of a cart.
 *
 * @param {Object} props    element's properties
 * @param {Object} classes  element's style classes
 *
 * @returns {JSX.Element}
 */
const ListItemCellCartStatus = (classes, props = {}) => {
  const { status, events = [] } = props

  const statusLabel = getFirstItem(events?.getStatus?.(status)) || {}

  const { lowercaseStatuses } = settings

  return (
    <Chip
      value={statusLabel?.value || '-'}
      color={statusLabel?.color}
      backgroundColor={statusLabel?.backgroundColor}
      textVariant={'14/bold'}
      size={'medium'}
      decorators={{ uppercase: lowercaseStatuses && def(lowercaseStatuses) ? !lowercaseStatuses : true }}
    />
  )
}

export default CellHOC(ListItemCellCartStatus, styles)
